import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

export interface MobileNumberIdentificationConfig {
  enabled: boolean;
}

const mobileNumberIdentificationConfigResource = createDocumentResource<MobileNumberIdentificationConfig>({
  name: 'mobileNumberIdentificationConfig',
  endpoint: 'v1/orgs/:orgId/configuration/mobile-number-lookup',
  observerCreator: emptyObserverCreator,
});

export default mobileNumberIdentificationConfigResource;
